import React, { useState, useEffect } from 'react';
import i18n from 'i18next'
import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/navigation';
import 'swiper/css/thumbs';
import './style.css';

import { FreeMode, Thumbs, Autoplay } from 'swiper/modules';

import { useTranslation, Trans } from 'react-i18next';

import r1 from '../../img/MansoryMesh/Main/r1.webp';
import r2 from '../../img/MansoryMesh/Main/r2.webp';
import r3 from '../../img/MansoryMesh/Main/r3.webp';
import r4 from '../../img/MansoryMesh/Main/r4.webp';

import Logo from '../../img/CompositeMesh/Main/Logo.png';

import { Link } from "react-router-dom"

function Main () {

    const { t } = useTranslation();

    const [thumbsSwiper, setThumbsSwiper] = useState(null);

    const [reloadKey, setReloadKey] = useState(0);
  
    useEffect(() => {
        setReloadKey(prev => prev + 1); // Обновляем ключ каждый раз при смене языка
    }, [i18n.language]);
      
    return(
        <div className="bg-[#1D1D1D]">
            <div className="max-w-[1220px] mx-[20px] md:mx-[40px] xl:mx-auto mt-[70px] md:mt-[200px] flex flex-col-reverse xl:flex-row justify-between">
                <div className='mt-[20px] xl:mt-0 relative'>
                    <Swiper
                        key={reloadKey}
                        spaceBetween={10}
                        thumbs={{ swiper: thumbsSwiper }}
                        modules={[FreeMode, Thumbs, Autoplay]}
                        className="mySwiper2 w-full xl:w-[593px] h-[300px] xl:h-[449px]"
                        autoplay={{
                            delay: 3000,
                            disableOnInteraction: false,
                        }}
                    >
                        <SwiperSlide>
                            <img src={r1} alt="" className='object-cover w-full h-[300px] xl:h-full'/>
                        </SwiperSlide>
                        <SwiperSlide>
                            <img src={r2} alt="" className='object-cover w-full h-[300px] xl:h-full'/>
                        </SwiperSlide>
                        <SwiperSlide>
                            <img src={r3} alt="" className='object-cover w-full h-[300px] xl:h-full'/>
                        </SwiperSlide>
                        <SwiperSlide>
                            <img src={r4} alt="" className='object-cover w-full h-[300px] xl:h-full'/>
                        </SwiperSlide>
                    </Swiper>       
                    <Swiper
                        onSwiper={setThumbsSwiper}
                        spaceBetween={10}
                        slidesPerView={4}
                        freeMode={true}
                        watchSlidesProgress={true}
                        modules={[FreeMode, Thumbs, Autoplay]}
                        className="mySwiper xl:w-[593px] mt-[17px]"
                        autoplay={{
                            delay: 3000,
                            disableOnInteraction: false,
                        }}
                    >
                        <SwiperSlide>
                            <img src={r1} alt="" className='cursor-pointer'/>
                        </SwiperSlide>
                        <SwiperSlide>
                            <img src={r2} alt="" className='cursor-pointer'/>
                        </SwiperSlide>
                        <SwiperSlide>
                            <img src={r3} alt="" className='cursor-pointer'/>
                        </SwiperSlide>
                        <SwiperSlide>
                            <img src={r4} alt="" className='cursor-pointer'/>
                        </SwiperSlide>
                    </Swiper>
                </div>
                <div className='flex flex-col'>
                    <p className='open-sans text-[50px] xl:text-[110px] text-[#F26522] leading-[1]'>{t('CompositeMesh.1')}</p>
                    <p className='text-[28px] xl:text-[45px] text-[#F26522] open-sans leading-[1.4] mt-[10px]'>{t('mansorymesh.1')}</p>
                    <p className='open-sans text-[14px] font-[300] xl:text-[16px] text-white mt-[15px] xl:mt-[35px] xl:max-w-[485px]'>{t('mansorymesh.2')}</p>
                    <p className='spanfont font-[300] open-sans text-[14px] xl:text-[16px] text-white xl:max-w-[485px] mt-[5px] xl:mt-[15px]'><Trans>{t('mansorymesh.3')}</Trans></p>
                    <Link to="/calculator">
                        <div className="contactus mt-[20px] xl:mt-[45px] !bg-[#F26522] mr-auto hover:scale-[1.1] transition-all">
                            <p className="text-[#1D1D1D] montserrat font-[600] text-[14px] xl:text-[16px]">{t('calc')}</p>
                        </div>
                    </Link>
                </div>
            </div>
        </div>
    );
}

export default Main;